import { useEffect, useRef, useState } from "react";
import Button from "./Button";
import styles from "./Server.module.css";
import React from "react";
import { flashAlert } from "../global_js";

function Server({ sd, disabled, removeEmployee }) {
  const [theServerName, setTheServerName] = useState(sd.ServerName);
  const firstUpdate = useRef(true);

  const user = JSON.parse(localStorage.getItem("userLogin")).userId;

  useEffect(() => {
    if (!firstUpdate.current) {
      const typingDelay = setTimeout(() => {
        saveName();
      }, 3000);

      return () => clearTimeout(typingDelay);
    }
  }, [theServerName]);

  function changeName(serverInput) {
    firstUpdate.current = false;
    setTheServerName(serverInput.target.value);
  }

  async function saveName() {
    if (theServerName) {
      await fetch("/api/servers", {
        method: "put",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          serverName: theServerName,
          banID: sd.BanID,
          id: sd.idServers,
          user: user,
        }),
      }).then(flashAlert("Employee name saved"));
    }
  }

  return (
    <tr>
      <td>
        <input
          type="text"
          className={styles.serverNameInput}
          value={theServerName}
          //id={index}
          //className={styles.serverInput}
          onChange={(e) => changeName(e)}
        />
      </td>
      <td>{sd.category}</td>
      <td>{Number(sd.Gratuity).toFixed(2)}</td>

      {removeEmployee && (
        <td>
          <Button
            type="primary"
            onClick={() =>
              removeEmployee({
                type: sd.category,
                empId: sd.idServers,
                user: user,
              })
            }
            disabled={disabled}
          >
            Remove
          </Button>
        </td>
      )}
    </tr>
  );
}

export default Server;
